import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { useAuthStore } from './auth.module';
import { useUserStore } from './user.module';
import { useCardFilterStore } from './cardFilter.module';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export { pinia, useAuthStore, useUserStore, useCardFilterStore };
